import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestContent() {
  const latest = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-600 text-sm">实时更新，发现最新精品资源</p>
          </div>
          <Link
            to="/category/zuixin"
            className="hidden sm:inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            全部最新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="animate-fade-in-up group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50"
              style={{ animationDelay: `${(idx + 1) * 0.1}s` }}
            >
              <div className="h-48 overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-600 text-xs whitespace-nowrap">
                  阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/zuixin"
            className="inline-flex items-center gap-1 text-primary-600 text-sm cursor-pointer whitespace-nowrap"
          >
            查看全部最新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}